import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isSidePanelOpen: false,
    isWindowDisconnectedFromSharedWorker: false,
    isSharedWorkerDead: false,
    reconnectToSharedWorker: false,
};

const generalSlice = createSlice({
    name: 'general',
    initialState,
    reducers: {
        setIsSidePanelOpen(state, { payload: isOpen }) {
            state.isSidePanelOpen = isOpen;
        },

        setIsWindowDisconnectedFromSharedWorker(state, { payload }) {
            state.isWindowDisconnectedFromSharedWorker = payload;
        },

        setIsSharedWorkerDead(state, { payload }) {
            state.isSharedWorkerDead = payload;
        },

        triggerWindowReconnectionToSharedWorker(state) {
            state.reconnectToSharedWorker = !state.reconnectToSharedWorker;
        },
    },
});

export const generalActions = generalSlice.actions;
export const generalReducer = generalSlice.reducer;
